import { BaseTypeSchema } from "../BaseTypeSchema";
import { VariableType } from "../VariableType";

export class DateSchema extends BaseTypeSchema
{
    static REGEX: RegExp = /^(?!0000)[0-9]{4}[\/-](?:0[1-9]|1[0-2])[\/-](?:0[1-9]|[12][0-9]|3[01])$/gm;
    constructor(required: boolean)
    {
        super(VariableType.Date, required);
    }
}